import { render, staticRenderFns } from "./userActivity.vue?vue&type=template&id=cb71454a&"
import script from "./userActivity.vue?vue&type=script&lang=js&"
export * from "./userActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports